import { Check16 } from '@yunex/yds-icons';
import React from 'react';
import { blue50, blue60 } from '../../../colors/blue';
import { gray20, gray40, white, whiteopacity80 } from '../../../colors/gray';
import { red03 } from '../../../colors/red';
import { rem } from '../../../utils/rem';
export var MuiCheckbox = {
    defaultProps: {
        color: 'primary',
        checkedIcon: React.createElement(Check16, null),
        icon: React.createElement(Check16, null),
        indeterminateIcon: React.createElement("div", { className: "MuiCheckbox-indeterminateIcon" }),
    },
    styleOverrides: {
        root: {
            backgroundColor: whiteopacity80,
            border: "".concat(rem(1), " solid ").concat(gray40),
            borderRadius: rem(1),
            color: gray20,
            cursor: 'pointer',
            height: rem(16),
            marginInline: rem(11),
            marginBlock: rem(5),
            padding: 0,
            width: rem(16),
            '&:hover': {
                backgroundColor: 'transparent',
                '& [class*=YdsSvgIcon-root]': { display: 'flex' },
            },
            '& [class*=YdsSvgIcon-root]': {
                height: rem(10),
                width: rem(10),
                display: 'none',
            },
            '&[class*=Mui-checked]': {
                backgroundColor: blue50,
                border: 'none',
                color: white,
                '&:hover': {
                    backgroundColor: blue60,
                },
                '& [class*=YdsSvgIcon-root]': {
                    display: 'flex',
                },
            },
            '& .MuiCheckbox-indeterminateIcon': {
                backgroundColor: blue50,
                height: rem(6),
                width: rem(6),
            },
            '&[class*=Mui-disabled]': {
                opacity: '0.4',
            },
            '&[class*=Mui-focusVisible]': {
                boxShadow: "0 0 0 ".concat(rem(2), " ").concat(blue60),
            },
            '&:hover .MuiCheckbox-indeterminateIcon': {
                backgroundColor: blue60,
            },
            '&[class*=Mui-error]': {
                border: "".concat(rem(1), " solid ").concat(red03),
                '&[class*=Mui-checked]': {
                    backgroundColor: red03,
                    '&:hover': {
                        backgroundColor: red03,
                    },
                },
                '& .MuiCheckbox-indeterminateIcon': {
                    backgroundColor: red03,
                },
                '&:hover .MuiCheckbox-indeterminateIcon': {
                    backgroundColor: red03,
                },
            },
        },
    },
};
